import React from 'react'
import styled from 'styled-components/macro'
import { Route, Routes } from 'react-router-dom'

import { Hero } from 'components/Hero'
import { About } from 'components/About'
import { Sponsors } from 'components/Sponsors'
import { PoweredBy } from 'components/PoweredBy'
import { Helmet, Nav, GATrackers } from '@tiltify/ui'
import { Games } from 'components/Games'
import { Schedule } from 'components/Schedule'
import { MediaDisplay } from 'components/MediaDisplay'
import { StartFundraising } from 'components/StartFundraising'
import { Leaderboard } from 'components/Leaderboard'
import { AllCampaignsComponent } from 'components/AllCampaigns'
import { CampaignSliderContainer } from 'components/CampaignSlider'
import { useRouteContext } from 'contexts/RouteContext'
import { Causes } from 'components/Causes'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat', sans-serif;
`

const StyledNav = styled(Nav)`
  color: #fff;
  background: #fff;
  z-index: 999;
  position: relative;
  width: 100%;

  nav button {
    border-radius: 4px;
  }

  && #signInButton {
    color: #000;
    font-weight: bold;
    font-size: 0.875rem;
    text-decoration: none;
    div {
      font-weight: bold;
    }
  }

  && #signUpButton {
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    background-color: #000;
    color: #fff;
    font-weight: bold;
    font-size: 0.875rem;
    text-decoration: none;
    border: 2px solid #000 !important;
    border-radius: 100px;
    div {
      font-weight: bold;
    }
  }
`

const App = (): JSX.Element => {
  const { fundraisingEvent, cause } = useRouteContext()
  return (
    <Wrapper>
      <GATrackers
        cause={cause}
        fundraisingEvent={fundraisingEvent}
        tracker={{
          trackingId: fundraisingEvent?.trackers && fundraisingEvent?.trackers[0],
          gaOptions: { name: 'activation', userId: fundraisingEvent?.legacyFundraisingEventId },
        }}
      />
      <Helmet
        description='Jingle Jam is fundraising on Tiltify'
        title='Jingle Jam'
        image={fundraisingEvent?.avatar?.src}
      />
      <StyledNav backgroundColor='#fff' />
      <Routes>
        <Route index element={<AppMain />} />
        <Route path='games' element={<Games viewAll />} />
        <Route path='campaigns' element={<AllCampaignsComponent />} />
      </Routes>
    </Wrapper>
  )
}

const AppMain = (): JSX.Element => {
  return (
    <Wrapper>
      <Hero />
      <MediaDisplay />
      <Schedule />
      <Games />
      <Causes />
      <StartFundraising />
      <Leaderboard />
      <CampaignSliderContainer />
      <Sponsors />
      <About />
      <PoweredBy />
    </Wrapper>
  )
}

export default App
